import { SkeletonSpinnerCentered } from '@civilgrid/ui/SkeletonLoader';
import { useParams } from '@tanstack/react-router';
import { useAsync } from 'react-use';
import { getProjectSummary } from '~/api/projects2';
import type { ProjectDetailsParams } from '..';
import Section from './Section';
import UpgradeButton from './UpgradeButton';

export default function EnvironmentalComponent() {
  const { projectId } = useParams({ strict: false }) as ProjectDetailsParams;
  const res = useAsync(async () => {
    return await getProjectSummary<{
      restrictedLandsUSGSProtectedAreas: number;
      terrestrialSpecies: number;
    }>(projectId, 'environmental');
  }, [projectId]);

  if (res.error) {
    console.error(res.error);
    return null;
  }

  const hasOverlap = res.value?.restrictedLandsUSGSProtectedAreas !== 0 || res.value?.terrestrialSpecies !== 0;

  return (
    <Section icon="🌿" title="Environmental">
      {res.loading ? (
        <SkeletonSpinnerCentered />
      ) : (
        <div className="space-y-2">
          {hasOverlap && (
            <div className="text-sm">
              Your project area may overlap{' '}
              <span className="font-semibold">USGS Protected Area and/or Threatened or Endangered Species</span>. It is
              crucial to engage with an expert and investigate this during early project planning.
              <br />
              <br />
            </div>
          )}
          Upgrade now to access the following datasets and analysis tools
          <div className="my-2 grid grid-cols-2 text-sm">
            <div>SWPPP Analysis</div>
            <div>FEMA Flood Maps</div>
            <div>Watershed</div>
            <div>Restricted Lands - Conservation Easement</div>
            <div>Restricted Lands - The California Protected Areas Database (CPAD)</div>
            <div>Restricted Lands - USGS Protected Areas</div>
            <div>Wetlands</div>
            <div>Avian Nests</div>
            <div>Critical Habitat</div>
          </div>
          <UpgradeButton>View Environmental</UpgradeButton>
        </div>
      )}
    </Section>
  );
}
